module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/21739a7b303ece303b023791813412cb.svg";